"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _glamor = require("glamor");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _FunctionContext = _interopRequireDefault(require("./FunctionContext"));
var _StateContext = _interopRequireDefault(require("./StateContext"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ROOT_CSS = (0, _glamor.css)({
  backgroundColor: 'rgba(0, 0, 0, .2)',
  borderRadius: 10,
  borderWidth: 0,
  bottom: 5,
  cursor: 'pointer',
  height: 20,
  outline: 0,
  position: 'absolute',
  right: 20,
  width: 20,
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, .4)'
  },
  '&:active': {
    backgroundColor: 'rgba(0, 0, 0, .6)'
  }
});
var _default = function _default(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return _react.default.createElement(_StateContext.default.Consumer, null, function (_ref2) {
    var sticky = _ref2.sticky;
    return !sticky && _react.default.createElement(_FunctionContext.default.Consumer, null, function (_ref3) {
      var scrollToEnd = _ref3.scrollToEnd;
      return _react.default.createElement("button", {
        className: (0, _classnames.default)(ROOT_CSS + '', (className || '') + ''),
        onClick: scrollToEnd
      }, children);
    });
  });
};
exports.default = _default;